import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { Input, Row, Card, Form, DatePicker, Col, Divider, Spin } from "antd";
import ApproveTreasuryBillContract from "./ApproveTreasuryBillContract";
import DisburseTreasuryBillContract from "./DisburseTreasuryBillContract";
import RejectTreasuryBillContract from "./RejectTreasuryBillContract";
import AmendTreasuryBillContract from "./AmendTreasuryBillContract";
import UndoTreasuryBillContractApproval from "./UndoATreasuryBillContractApproval";
import TerminateTreasuryBillContract from "./TerminateTreasuryBillContract";
import RolloverTreasuryBillContract from "./RolloverTreasuryBillContract";
import CloseDealTreasuryBillContract from "./CloseDealTreasuryBillContractAction";

const { TextArea } = Input;
const TreasuryBillMainActionPage = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // console.log(state);
  }, []);

  const renderActions = () => {
    switch (state?.actionLabel?.toLowerCase()) {
      // case "modify application":
      //   return <ModifySavingsAccount userData={userData} />;
      case "approve deal":
        return <ApproveTreasuryBillContract userData={userData} />;
      case "disburse deal":
        return <DisburseTreasuryBillContract userData={userData} />;
      case "reject deal":
        return <RejectTreasuryBillContract userData={userData} />;
      case "amend deal":
        return <AmendTreasuryBillContract userData={userData} />;
      case "undo approval":
        return <UndoTreasuryBillContractApproval userData={userData} />;
      case "terminate deal":
        return <TerminateTreasuryBillContract userData={userData} />;
      case "rollover deal":
        return <RolloverTreasuryBillContract userData={userData} />;
      case "close deal":
        return <CloseDealTreasuryBillContract userData={userData} />;

      // case "close":
      //   return <CloseSavingsAcc userData={userData} />;

      default:
        return <>No {state.actionLabel} Component found contact dev</>;
    }
  };
  return <>{renderActions()}</>;
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
export default connect(mapStateToProps, null)(TreasuryBillMainActionPage);
